import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=d5d0a4f0"
import script from "./Language.vue?vue&type=script&lang=ts"
export * from "./Language.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports